<div>
  <div class="col-md-12 col-lg-12">
    <div class="col-sm-3"><h4><b>{{ 'pages.createReceiptPage.miscAwb.Details' | translate }}</b></h4></div>
  </div>
</div>
<div *ngIf="isRequiredShipmentNumber">
  <div class="col-md-4 col-lg-4 col-sm-10 mrgin-lft">
    <div class="form-group">
      <label for="awb">{{ 'pages.createReceiptPage.miscAwb.enterAWBRelated' | translate }}</label>
      <input class="form-control" style="resize:none" id="awb" placeholder="EX 81812373673" [(ngModel)]="shipmentNumber"/>
      <span *ngIf="validateAWB"><i class="armx-icon armx-cancel" style="color:#dc291e"></i> {{ 'pages.createReceiptPage.miscAwb.plsEntreAWBRelated' | translate }}</span>
    </div>
    <div class="row">
      <div class="col-md-4">
        <button class="btn btn-primary" (click)="serachAwbNumber()">{{ 'common.search' | translate }}</button>
      </div>
    </div>
  </div>
</div>
<div class="row"></div>
<div *ngIf="isRequiredComments">
  <div class="col-md-4 col-lg-4 col-sm-10 mrgin-top2 mrgin-lft">
    <div class="form-group">
      <label>{{ 'pages.createReceiptPage.miscAwb.comment' | translate }}</label>
      <input #comt type="text" [(ngModel)]="comment" (blur)="validateAndEmitComment()" class="form-control"  placeholder="Enter your comment">
    </div>
    <span *ngIf="validateComment"><i class="armx-icon armx-cancel" style="color:#dc291e"></i> {{ 'pages.createReceiptPage.miscAwb.fillComment' | translate }}</span>
  </div>
</div>
<div class="row"></div>
<div>
  <div class="col-md-4 col-lg-4 col-sm-10 mrgin-top2 mrgin-lft">
    <div class="form-group">
      <label for="amt">{{ 'pages.createReceiptPage.miscAwb.theAmount' | translate }}</label>
      <input #amt type="number" [(ngModel)]="amount" (blur)="validateAndEmitAmount()" class="form-control" id="amt" placeholder="0">
    </div>
    <span *ngIf="validateAmount"><i class="armx-icon armx-cancel" style="color:#dc291e"></i> {{ 'pages.createReceiptPage.miscAwb.fillAmount' | translate }}</span>
  </div>
</div>

